import { AccountRoles } from "./accountroles.model";

export class UserRequest {

    public firstName: string;    
    public lastName: string;
    public emailAddress: string;
    public accountRoles: Array<AccountRoles>;
}